export const ASSIGN_PROJECT_LIST_REQUEST = 'ASSIGN_PROJECT_LIST_REQUEST'
export const ASSIGN_PROJECT_LIST_SUCCESS = 'ASSIGN_PROJECT_LIST_SUCCESS'
export const ASSIGN_PROJECT_LIST_FALUIRE = 'ASSIGN_PROJECT_LIST_FALUIRE'
